type DirectusAssetInput = unknown;

function resolveAssetRef(value: DirectusAssetInput, seen = new WeakSet<object>()): string | null {
    if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed || trimmed === "[object Object]") return null;
        return trimmed;
    }

    if (typeof value === "number") {
        return String(value);
    }

    if (!value || typeof value !== "object") {
        return null;
    }

    if (seen.has(value)) {
        return null;
    }
    seen.add(value);

    const obj = value as Record<string, unknown>;

    const directKeys = ["id", "directus_files_id", "file", "asset", "image", "url"];
    for (const key of directKeys) {
        if (!(key in obj)) continue;
        const resolved = resolveAssetRef(obj[key], seen);
        if (resolved) return resolved;
    }

    return null;
}

export const getDirecutsImageUrl = (value: DirectusAssetInput): string => {
    const cmsBase = (process.env.NEXT_PUBLIC_CMS_URL ?? "https://noshit.cms.curious.zone").replace(/\/+$/, "");
    const ref = resolveAssetRef(value);

    if (!ref) return "";
    if (/^https?:\/\//i.test(ref)) return ref;

    return `${cmsBase}/assets/${ref}`;
};
